import { communicationModule, CommunicationApiInstance } from '@interhyp/module-communication';
import { configurationModule } from '@interhyp/module-configuration';
import { getConnection } from '@interhyp/util-request';
import { createStore } from 'redux-dynamic-modules';
import thunk from 'redux-thunk';

import { companyModule } from './Company/module';
import { sessionModule } from './StateSession/module';

getConnection().setPrefix('/sales');
const store = createStore(
  {
    extensions: [
      {
        middleware: [thunk.withExtraArgument({ api: CommunicationApiInstance })],
      },
    ],
  },
  companyModule(),
  sessionModule(),
  communicationModule,
  configurationModule,
);

export { store };
